import {ApiClient as Api} from '@hconnect/apiclient'

import type {
  AddReportLinkRequest,
  CommentDto,
  CreateCommentRequest,
  CreateReportRequest,
  ReportLinkDto,
  ReportSummaryDto,
  RiaDetailDto,
  UpdateReportSiteRequest,
  UpdateRiaDetailsRequest,
  UpdateRiaStatusRequest
} from '../types'

export const riskSurveyMutations = {
  importReport: async (data: CreateReportRequest) => {
    const response = await Api.axiosInstance.post<ReportSummaryDto>('/risk-survey/reports', data)
    return response.data
  },

  updateRiaStatus: async (riaId: string, data: UpdateRiaStatusRequest) => {
    const response = await Api.axiosInstance.patch<RiaDetailDto>(
      `/risk-survey/rias/${encodeURIComponent(riaId)}/status`,
      data
    )
    return response.data
  },
  updateRiaDetails: async (riaId: string, data: UpdateRiaDetailsRequest) => {
    const response = await Api.axiosInstance.patch<RiaDetailDto>(
      `/risk-survey/rias/${encodeURIComponent(riaId)}/details`,
      data
    )
    return response.data
  },
  addComment: async (riaId: string, data: CreateCommentRequest) => {
    const response = await Api.axiosInstance.post<CommentDto>(
      `/risk-survey/rias/${encodeURIComponent(riaId)}/comments`,
      data
    )
    return response.data
  },

  archiveReport: async (reportId: string) => {
    const response = await Api.axiosInstance.post<ReportSummaryDto>(
      `/risk-survey/reports/${encodeURIComponent(reportId)}/archive`
    )
    return response.data
  },
  unarchiveReport: async (reportId: string) => {
    const response = await Api.axiosInstance.post<ReportSummaryDto>(
      `/risk-survey/reports/${encodeURIComponent(reportId)}/unarchive`
    )
    return response.data
  },

  updateReportSite: async (reportId: string, data: UpdateReportSiteRequest) => {
    const response = await Api.axiosInstance.patch<ReportSummaryDto>(
      `/risk-survey/reports/${encodeURIComponent(reportId)}/site`,
      data
    )
    return response.data
  },

  addReportLink: async (reportId: string, data: AddReportLinkRequest) => {
    const response = await Api.axiosInstance.post<ReportLinkDto>(
      `/risk-survey/reports/${encodeURIComponent(reportId)}/links`,
      data
    )
    return response.data
  },

  deleteReportLink: async (reportId: string, linkId: string) => {
    await Api.axiosInstance.delete(
      `/risk-survey/reports/${encodeURIComponent(reportId)}/links/${encodeURIComponent(linkId)}`
    )
  }
}
